module.exports = __webpack_public_path__ + "media/images/icon/payment/cart-bb08c4aa3250fc04e068a8d36d805a06.svg";